import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {withApollo} from 'react-apollo';
import {withTranslation} from 'react-i18next';
import {COLORS, FILTER_OPERATOR, ORDER_DIRECTION} from '../../constants';
import Error from '../Error/Error';
import SearchSelect from '../layout/SearchSelect';

const GRAPHQL_QUERY_USER_BRAND = gql`
  query($criteria: CriteriaInput) {
    currentUser {
      id
      brands(criteria: $criteria) {
        id
        rows {
          id
          name
        }
      }
    }
  }
`;

const SelectUserBrand = ({t, client, placeholder, ...props}) => {

  const colourStyles = {
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: COLORS.PINK_TAG,
        color: COLORS.WHITE,
        borderRadius: 20,
      };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      color: COLORS.WHITE,
      fontSize: 12,
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: COLORS.WHITE,
      ':hover': {
        backgroundColor: COLORS.DARK_PINK,
        borderRadius: 20,
        color: COLORS.WHITE,
        cursor: 'pointer',
      },
    }),
  };

  const [error, setError] = useState(null);

  const loadOptions = (inputValue, callback) => {
    const parsedOptions = [];
    setError(null);
    client
      .query({
        query: GRAPHQL_QUERY_USER_BRAND,
        variables: {
          criteria: {
            filters: [
              {field: 'name', operator: FILTER_OPERATOR.Like, value: '%' + inputValue + '%'},
            ],
            limit: 10,
            offset: 0,
            order: {direction: ORDER_DIRECTION.ASC, field: 'name'},
          },
        },
      })
      .then(({data}) => {
        const parsedOptions = data.currentUser.brands.rows.map(row => ({value: row.id, label: row.name}));
        callback(parsedOptions);
      })
      .catch(error => {
        setError(t('unknownError'));
        console.error('Error : ', error);
        callback(parsedOptions);
      });
  };

  return (
    <>
      <SearchSelect
        styles={colourStyles}
        loadOptions={loadOptions}
        isMulti={true}
        placeholder={placeholder ? placeholder : t('selectUserBrandPlaceholder')}
        {...props}
      />
      <Error error={error}/>
    </>
  );
};

SelectUserBrand.defaultProps = {
  placeholder: null,
};

SelectUserBrand.propTypes = {
  t: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default withApollo(withTranslation('common')(SelectUserBrand));
